import { WixSDK } from '../wix-sdk';
let instanceGetter = global.Wix
    ? WixSDK.Utils.getInstance
    : null;
export const getAuthorizationToken = () => {
    const BMApi = global.BusinessManagerAPI;
    if (BMApi && Object.keys(BMApi).length) {
        return BMApi.getCurrentInstance(BMApi.appDefIds.video);
    }
    if (instanceGetter) {
        return instanceGetter();
    }
    return null;
};
export const getAuthHeader = () => {
    if (global.__MEDIA_TOKEN__) {
        // Dashboard
        const headers = {
            'X-WIX-SITE-TOKEN': global.__MEDIA_TOKEN__,
        };
        if (global.BusinessManagerAPI &&
            Object.keys(global.BusinessManagerAPI).length) {
            return {
                ...headers,
                Authorization: global.BusinessManagerAPI.getCurrentInstance(global.BusinessManagerAPI.appDefIds.video),
            };
        }
        return headers;
    }
    const instance = instanceGetter && instanceGetter();
    if (!instance) {
        return null;
    }
    return {
        'X-WIX-INSTANCE-TOKEN': instance,
    };
};
export function setInstanceGetter(_instanceGetter) {
    instanceGetter = _instanceGetter;
}
//# sourceMappingURL=get-auth-header.js.map